import { create } from "zustand";

export const useGradeFilterStore = create((set) => ({
  // Default: all ranges enabled
  enabledRanges: {
    range0: true, // 2+
    range1: true, // 1.5 - 2
    range2: true, // 1 - 1.5
    range3: true, // 0.6 - 1
    range4: true, // 0 - 0.6
  },
  toggleRange: (rangeKey) => set((state) => ({
    enabledRanges: {
      ...state.enabledRanges,
      [rangeKey]: !state.enabledRanges[rangeKey],
    }
  })),
  setAllRanges: (enabled) => set({
    enabledRanges: {
      range0: enabled,
      range1: enabled,
      range2: enabled,
      range3: enabled,
      range4: enabled,
    }
  }),
}));

